module.exports = __webpack_public_path__ + "media/images/icons/flags/AS-4aa6ac65a93fe69f8c055f8b29a43cf4.svg";